var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHappyClients(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 100.353 100.353",
    style: {
      enableBackground: "new 0 0 100.353 100.353"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M49.106,50.437c-12.167,0-22.066,9.898-22.066,22.065c0,0.828,0.671,1.5,1.5,1.5h41.131c0.828,0,1.5-0.672,1.5-1.5 C71.171,60.335,61.272,50.437,49.106,50.437z M30.099,71.002c0.768-9.814,9-17.565,19.007-17.565 c10.007,0,18.239,7.751,19.006,17.565H30.099z",
    id: "id_101",
    style: {
      fill: "rgb(242, 34, 79)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.746,48.456c7.143,0,12.954-5.811,12.954-12.954c0-7.143-5.812-12.954-12.954-12.954 c-7.143,0-12.954,5.811-12.954,12.954C35.792,42.645,41.603,48.456,48.746,48.456z M48.746,25.548c5.488,0,9.954,4.465,9.954,9.954 c0,5.488-4.466,9.954-9.954,9.954c-5.489,0-9.954-4.465-9.954-9.954C38.792,30.013,43.257,25.548,48.746,25.548z",
    id: "id_102",
    style: {
      fill: "rgb(8, 8, 8)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.78,58.714c2.461,0,4.878,0.656,6.99,1.898c0.714,0.422,1.634,0.181,2.053-0.532c0.42-0.714,0.182-1.634-0.533-2.054 c-2.572-1.513-5.515-2.312-8.51-2.312c-9.257,0-16.788,7.531-16.788,16.788c0,0.828,0.671,1.5,1.5,1.5h19.012 c0.829,0,1.5-0.672,1.5-1.5s-0.671-1.5-1.5-1.5H6.073C6.823,64.102,12.684,58.714,19.78,58.714z",
    id: "id_103",
    style: {
      fill: "rgb(247, 40, 85)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.514,53.319c5.521,0,10.014-4.492,10.014-10.014c0-5.522-4.492-10.014-10.014-10.014 c-5.522,0-10.014,4.492-10.014,10.014C9.5,48.826,13.992,53.319,19.514,53.319z M19.514,36.291c3.867,0,7.014,3.146,7.014,7.014 c0,3.867-3.146,7.014-7.014,7.014c-3.868,0-7.014-3.146-7.014-7.014C12.5,39.437,15.646,36.291,19.514,36.291z",
    id: "id_104",
    style: {
      fill: "rgb(242, 34, 79)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.553,55.714c-2.994,0-5.937,0.8-8.51,2.312c-0.715,0.42-0.953,1.339-0.533,2.053c0.42,0.716,1.342,0.953,2.053,0.533 c2.113-1.242,4.53-1.898,6.99-1.898c7.096,0,12.957,5.388,13.707,12.288H74.832c-0.828,0-1.5,0.672-1.5,1.5s0.672,1.5,1.5,1.5 h19.009c0.828,0,1.5-0.672,1.5-1.5C95.341,63.245,87.81,55.714,78.553,55.714z",
    id: "id_105",
    style: {
      fill: "rgb(237, 38, 88)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.82,53.319c5.521,0,10.014-4.492,10.014-10.014c0-5.522-4.492-10.014-10.014-10.014 c-5.522,0-10.015,4.492-10.015,10.014C68.806,48.826,73.298,53.319,78.82,53.319z M78.82,36.291c3.867,0,7.014,3.146,7.014,7.014 c0,3.867-3.146,7.014-7.014,7.014c-3.868,0-7.015-3.146-7.015-7.014C71.806,39.437,74.952,36.291,78.82,36.291z",
    id: "id_106",
    style: {
      fill: "rgb(237, 38, 71)"
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHappyClients);
export default __webpack_public_path__ + "static/media/happyClients.c4265c9e6dbf302d19ebc57c5d51daec.svg";
export { ForwardRef as ReactComponent };